// extracted by mini-css-extract-plugin
export default {"doctorsPage":"Doctors_doctorsPage__kiUkg","pageTitle":"Doctors_pageTitle__HGJGa","titleText":"Doctors_titleText__xCwnC","titleLogo":"Doctors_titleLogo__sAlly"};